import { LocalStorage } from '@sveltia/utils/storage';

// @gitbase
import { getGitbaseMode } from '$lib/services/integrations/gitbase/mode';
import {
  clearGitbaseUserCache,
  setGitbaseUserCache,
} from '$lib/services/integrations/gitbase/auth-storage';

/**
 * @import { User } from '$lib/types/private';
 */

/**
 * @type {{ account: User | null | undefined }}
 */
export const user = $state({ account: undefined });

$effect.root(() => {
  $effect(() => {
    const _user = user.account;

    (async () => {
      try {
        // @gitbase
        if (getGitbaseMode()) {
          if (_user) {
            await setGitbaseUserCache(_user);
          } else if (_user === null) {
            await clearGitbaseUserCache();
          }

          return;
        }

        if (_user) {
          await LocalStorage.set('sveltia-cms.user', _user);
        } else if (_user === null) {
          await LocalStorage.delete('sveltia-cms.user');
        }
      } catch {
        //
      }
    })();
  });
});
